import { render, staticRenderFns } from "./RequestToJoinProject.vue?vue&type=template&id=f5b04586&scoped=true"
import script from "./RequestToJoinProject.vue?vue&type=script&lang=js"
export * from "./RequestToJoinProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b04586",
  null
  
)

export default component.exports